/**
 * Web shim for react-native-keyboard-controller
 *
 * This native-only package isn't needed on web — the browser handles
 * keyboard avoidance natively. We re-export View as a passthrough
 * so existing imports resolve without pulling in native code.
 */
const React = require('react');
const { View } = require('react-native');

const makePassthrough = (name) => {
  const Component = React.forwardRef(({ children, ...rest }, ref) =>
    React.createElement(View, { ...rest, ref }, children)
  );
  Component.displayName = name;
  return Component;
};

const KeyboardAvoidingView = makePassthrough('KeyboardAvoidingView');
const KeyboardAwareScrollView = makePassthrough('KeyboardAwareScrollView');
const KeyboardControllerView = makePassthrough('KeyboardControllerView');

const KeyboardProvider = ({ children }) => children;
KeyboardProvider.displayName = 'KeyboardProvider';

const KeyboardController = {
  setInputMode: () => {},
  setDefaultMode: () => {},
  dismiss: () => {},
};

const shimExports = {
  __esModule: true,
  KeyboardAvoidingView,
  KeyboardAwareScrollView,
  KeyboardController,
  KeyboardControllerView,
  KeyboardProvider,
  KeyboardEvents: {
    addListener: () => ({ remove: () => {} }),
  },
  useKeyboardController: () => ({
    enabled: true,
    setEnabled: () => {},
  }),
  useKeyboardHandler: () => {},
  useReanimatedKeyboardAnimation: () => ({
    height: { value: 0 },
    progress: { value: 0 },
    state: { value: 0 },
  }),
  useFocusedInputHandler: () => {},
  AndroidSoftInputModes: {
    SOFT_INPUT_ADJUST_NOTHING: 0,
    SOFT_INPUT_ADJUST_PAN: 16,
    SOFT_INPUT_ADJUST_RESIZE: 32,
    SOFT_INPUT_ADJUST_UNSPECIFIED: 0,
  },
};

// Provide a default export so `import KeyboardController from '...'` resolves
// to the controller stub rather than undefined (required when __esModule: true).
shimExports.default = shimExports;
module.exports = shimExports;
